<div class="contenido-flujo">
    <div class="contenido-texto">
        <div class="contenido-titulo">
            <label class="type-user"  [ngStyle]="{'color': color}">
                {{typeUser}}
            </label>
            <app-label-chips *ngIf="showLabel" [estado]="'proceso'" [tipo]="'chipIcon'" [iconLabel]="faCommentAltLines" 
                [accionPopover]="true" [positionPopover]="positionPopover" [tituloPopover]="tituloPopover" [mensajePopover]="mensajePopover"> 1
            </app-label-chips>
        </div>
        <label class="user">
            {{user}}
        </label>
    </div> 
    <div class="contenido-flecha" *ngIf="!isLast">
        <fa-icon [icon]="faChevronRight"></fa-icon>
    </div>
</div>